"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _component = _interopRequireWildcard(require("../base/component"));

var _icon = _interopRequireDefault(require("../icon"));

var _index = _interopRequireDefault(require("../notification/index"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var NumberInput = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(NumberInput, _KZUIComponent);

  var _super = _createSuper(NumberInput);

  function NumberInput(props) {
    var _this;

    _classCallCheck(this, NumberInput);

    _this = _super.call(this, props);

    _this.autoBind('onIncrease', 'onDecrease', 'setValue', 'handleInput', 'handleBlur');

    _this.state = {
      value: undefined
    };
    return _this;
  }

  _createClass(NumberInput, [{
    key: "initStateFromProps",
    value: function initStateFromProps(props) {
      var value = props.value;

      if (typeof value == 'undefined') {
        return {
          value: value
        };
      }

      if (typeof value !== 'undefined' && isNaN(value) && value !== 0) {
        _index["default"].error('请输入数字');

        return {
          value: undefined
        };
      }

      return {
        value: Number(value)
      };
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      var _this2 = this;

      var _this$props = this.props,
          min = _this$props.min,
          max = _this$props.max;
      /* TODO  FIX BUG 
      * 如果最小值 | 最大值 突变，value无法一步满足要求怎么办
      */

      if ((min ? Number(value) >= min : true) && (max ? Number(value) <= max : true)) {
        setTimeout(function () {
          _this2.setState({
            value: Number(value)
          });
        }, 0);

        if (this.props.onChange) {
          this.props.onChange({
            value: Number(value),
            name: this.props.name
          });
        }
      }
    }
  }, {
    key: "onIncrease",
    value: function onIncrease(e) {
      e.stopPropagation();
      this.setValue(Number(this.state.value || 0) + this.props.step);
    }
  }, {
    key: "onDecrease",
    value: function onDecrease(e) {
      e.stopPropagation();
      this.setValue(Number(this.state.value || 0) - this.props.step);
    }
  }, {
    key: "handleInput",
    value: function handleInput(e) {
      this.setValue(e.target.value);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      var _this$props$onBlur, _this$props2;

      var value = e.target.value;

      if (typeof value !== 'undefined' && isNaN(value) && value !== 0) {
        _index["default"].error('请输入数字');

        this.setState({
          value: null
        });

        if (this.props.onChange) {
          this.props.onChange({
            value: null,
            name: this.props.name
          });
        }

        return;
      }

      (_this$props$onBlur = (_this$props2 = this.props).onBlur) === null || _this$props$onBlur === void 0 ? void 0 : _this$props$onBlur.call(_this$props2, e);
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var clsPrefix = 'kui-number-input';
      var _this$props3 = this.props,
          className = _this$props3.className,
          style = _this$props3.style,
          disabled = _this$props3.disabled,
          error = _this$props3.error,
          size = _this$props3.size,
          name = _this$props3.name,
          min = _this$props3.min,
          max = _this$props3.max,
          step = _this$props3.step,
          placeholder = _this$props3.placeholder;
      var cls = (0, _classnames["default"])(clsPrefix, className, (_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix, "-error"), error), _defineProperty(_classNames, "".concat(clsPrefix, "-disabled"), disabled), _defineProperty(_classNames, "".concat(clsPrefix, "-").concat(size), true), _classNames));
      var noIncrease = typeof max === 'number' ? Number(this.state.value) + step > Number(max) : false;
      var noDecrease = typeof min === 'number' ? Number(this.state.value) - step < Number(min) : false;
      var noIncreaseCls = noIncrease ? "".concat(clsPrefix, "-disabled") : '';
      var noDecreaseCls = noDecrease ? "".concat(clsPrefix, "-disabled") : '';
      return /*#__PURE__*/React.createElement("div", {
        className: cls,
        style: style // disabled={disabled}

      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        name: name,
        value: this.state.value,
        disabled: disabled,
        placeholder: placeholder,
        onInput: this.handleInput,
        onBlur: this.handleBlur
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-controls")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-increase ").concat(noIncreaseCls),
        onClick: this.onIncrease,
        role: "button",
        tabIndex: 0
      }, /*#__PURE__*/React.createElement(_icon["default"], {
        type: "drop-up"
      })), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-decrease ").concat(noDecreaseCls),
        onClick: this.onDecrease,
        role: "button",
        tabIndex: 0
      }, /*#__PURE__*/React.createElement(_icon["default"], {
        type: "drop-down"
      }))));
    }
  }]);

  return NumberInput;
}(_component["default"]);

_defineProperty(NumberInput, "defaultProps", _objectSpread(_objectSpread({}, _component.baseDefaultProps), {}, {
  size: 'normal',
  disabled: false,
  error: false,
  name: '',
  value: undefined,
  step: 1,
  min: 0,
  max: undefined,
  onChange: null,
  placeholder: ''
}));

var _default = NumberInput;
exports["default"] = _default;